module.exports = __webpack_public_path__ + "img/38759-009.71a43814.jpg";